export default {
  new_tag: 'New',
  groups: {
    dashboards: 'Dashboards',
    online_shop: 'Online Shop',
    home: 'Home',
    marketing: 'Marketing',
    reservations: 'Reservations',
    website: 'Website',
    orders_portal: 'Launch orders portal',
    roi: 'ROI',
    google_ads: 'Google Ads',
    mobile_app: 'Mobile App',
    phone_answering: 'Phone Answering',
    pricing: 'Pricing',
    team: 'Team',
    data_deletion_requests: 'Data deletion requests',
    partner: 'Partner',
  },
  get_started: {
    title: 'Get Started',
  },
  onboarding: {
    title: 'Launch',
  },
  new_restaurant: {
    title: 'New Restaurant',
  },
  gift_cards: {
    title: 'Gift Cards',
  },
  top_items: {
    title: 'Top Items',
  },
  dashboards: {
    title: 'Dashboards',
    children: {
      general: 'General',
      restaurant_details: 'Restaurant Details',
      external_delivery: 'External Delivery',
      overview: 'Overview',
      orders: 'Orders by source',
      google: 'Google',
      customers: 'Customers',
    },
  },
  customer_base: {
    title: 'Customer Base',
  },
  new_company: {
    title: 'New restaurant',
  },
  agent_ops_queue: {
    title: 'AI Suggestions',
  },
  external_delivery_support: {
    title: 'External delivery support',
  },
  payment_gateways: {
    title: 'Payment Gateways',
  },
  developers: {
    title: 'Developers',
  },
  feature_flags: {
    title: 'Feature Flags',
  },
  platform_agent_log: {
    title: 'Amigo log',
  },
  test_restaurants: {
    title: 'Test restaurants',
  },
  partners: {
    title: 'Partners',
  },
  partner: {
    children: {
      account: 'Account',
      branding: 'Branding',
      payment_gateway: 'Payment gateway',
      billing: 'Billing',
      tax_currency: 'Tax & Currency',
      service_fee_calculator: 'Service fee calculator',
      processing_fees: 'Processing fees',
    },
  },
  going_live: {
    title: 'Going live',
    children: {
      setup_package_fulfillments: 'Logsta fulfillments',
      polygraphy: 'Print Products',
    },
  },
  franchises: {
    title: 'Brands',
  },
  setup_package_fulfillments: {
    title: 'Setup package fulfillments',
  },
  website: {
    title: 'Website',
    children: {
      storefront: 'Storefront',
      studio: 'Studio (V1)',
      studio_v2: 'Studio (V2)',
    },
  },
  reservations: {
    title: 'Reservation',
    children: {
      overview: 'Overview',
      booking_availability: 'Booking Availability',
      settings: 'Settings',
      general: 'General',
      storefront: 'Storefront',
    },
  },
  subscriptions: {
    title: 'Subscriptions',
    children: {
      subscriptions: 'Subscriptions',
      products: 'Products',
    },
  },
  sales: {
    title: 'Sales',
    children: {
      orders: 'Orders',
      receipts: 'Customer receipts',
      external_deliveries: 'External deliveries',
    },
  },
  billing: {
    title: 'Reports',
    children: {
      monthly_statements: 'Monthly Statements',
      payouts: 'Payouts',
      invoices: 'Invoices',
      subscription: 'Subscription',
      sales_summary: 'Sales Summary',
      internal_invoice_items: 'Internal invoice items',
      income_reports: 'Income reports',
      tax_reports: 'Tax reports',
    },
  },
  master_menu: {
    title: 'Brand sync',
  },
  menu: {
    title: 'Menu',
    children: {
      master_overview: 'Brands',
      manage_menus: 'Manage menus',
      modifiers: 'Modifiers',
      smart_pricing: 'Smart pricing',
      upsell_items: 'Upsell items',
      sold_out_items: 'Sold out items',
      import: 'Import',
      edit_history: 'Edit history',
    },
  },
  my_store: {
    title: 'My info',
    children: {
      settings: 'Profile',
      gallery: 'Gallery',
      business_information: 'Business Information',
      documents: 'My documents',
      personal_information: 'Personal Information',
      bank_info: 'Bank Details',
      tax_info: 'Tax Details',
      shipping_info: 'Shipping Details',
      google_profile: 'Google profile',
      seo: 'SEO',
      impressum: 'Impressum',
      imprint: 'Imprint',
      post_launch: 'Post-Launch',
      tax_currency: 'Tax & Currency',
    },
  },
  opening_hours: {
    title: 'Opening hours & Location',
    children: {
      opening_hours: 'Opening hours',
      location: 'Location',
    },
  },
  order_settings: {
    title: 'Order settings',
    children: {
      takeout: 'Order Methods',
      missed_orders: 'Missed orders',
      order_layout: 'Order Layout',
      payment_methods: 'Payment methods',
      connect_paypal: 'Connect paypal',
      tips: 'Tips',
      service_fee: 'Fees',
      processing_fees: 'Processing fees',
      receipt: 'Receipt',
      staff_credentials: 'Staff credentials',
      integrations: 'Integrations',
      terminal: 'Terminal',
      invoices: 'Invoices',
    },
  },
  mobile_app: {
    title: 'Mobile App',
    children: {
      overview: 'Overview',
      updates: 'Updates',
      intro_screen: 'Intro Screen',
    },
  },
  marketing: {
    children: {
      overview: 'Overview',
      followers: 'Followers',
      email_messages: 'Email messages',
      push_notifications: 'Push notifications',
      promo_codes: 'Promo codes',
      offers: 'Offers',
      google_business: 'Google Business',
      google_review_program: 'Google review program',
      loyalty_program: 'Loyalty program',
      polygraphy: 'Print Products',
      tracking_links: 'Tracking Links',
      google_ads: 'Google Ads',
      website_analytics: 'Website Analytics',
      featured_posts: 'Posts Mobile App',
    },
  },
  loyalty_tablet: {
    title: 'Loyalty Tablet',
    children: {
      dashboard: 'Dashboard',
      settings: 'Settings',
      credentials: 'Credentials',
    },
  },
  contract: {
    title: 'Contract',
    children: {
      agreement: 'Agreement',
      template: 'Template',
    },
  },
  team: {
    children: {
      managers: 'Managers',
      reports: 'Reports',
    },
  },
};
